import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'
import translations from './modules/translations'
import lastUpdateTime from './modules/lastUpdateTime'
import charts from './modules/charts'
import generic from './modules/filtersGeneric'
import filterSave from './modules/filterSave'
import snackBar from './modules/snackBar'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authToken: '',
    currency: ''
  },
  getters,
  mutations,
  actions,
  modules: {
    translations,
    lastUpdateTime,
    charts,
    generic,
    filterSave,
    snackBar
  }
})
